import { render, staticRenderFns } from "./WIN_features_module_two.vue?vue&type=template&id=4981b0e4&"
import script from "./WIN_features_module_two.vue?vue&type=script&lang=js&"
export * from "./WIN_features_module_two.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports